import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_SCHEDULE_ASSIGNMENTS } from "../../feature-flag-schedule-assignments"

/**
 * Whether the trade editor's Save is blocked.
 *
 * @param {{ tradeName?: string, skills?: object[] }} target - What the editor holds now
 * @param {{ tradeId?: string, skills?: object[] } | null} mapping - The trade as it was opened
 * @returns {boolean}
 */
export function isEditMappingInvalid(target, mapping) {
    if (!target?.tradeName?.trim()) return true
    if (!target?.skills?.length && !mayHaveNoSkills(mapping)) return true
    return false
}

// FIQ-2457: with the flag on, a trade can be set up with no skills, to receive schedule
// assignments. Without it, a trade that already has none (made while the flag was on, or
// emptied by moving its skills to other trades) can still be renamed
function mayHaveNoSkills(mapping) {
    return isEnabled(FEATURE_FLAG_SCHEDULE_ASSIGNMENTS) || (!!mapping?.tradeId && !mapping?.skills?.length)
}
